import { useAppLocation } from '@crm/hooks/useAppLocation'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { useLocales } from '@shared/locales'
import { type TabsProps, Card, Tabs } from 'antd'
import { Outlet, useParams } from 'react-router-dom'

export const InfoTabsOpportunities = () => {
  const { t } = useLocales()
  const { opportunityId, id } = useParams()
  const { pathname } = useAppLocation()
  const navigate = useAppNavigate()

  const domainName = window.location.hostname.split('.')[0]
  const isTrendsetterDomain = domainName === 'trendsetter'

  const items: TabsProps['items'] = [
    {
      key: `/opportunities/${opportunityId}/details/${id}`,
      label: t('lead.activity')
    },
    {
      key: `/opportunities/${opportunityId}/details/${id}/products`,
      label: t('menu.products')
    },
    {
      key: `/opportunities/${opportunityId}/details/${id}/contracts`,
      label: t('lead.contracts')
    },
    ...(isTrendsetterDomain
      ? [
          {
            key: `/opportunities/${opportunityId}/details/${id}/offers`,
            label: t('lead.offers')
          },
          {
            key: `/opportunities/${opportunityId}/details/${id}/payment-accounts`,
            label: 'Cont de plată'
          }
        ]
      : []),
    {
      key: `/opportunities/${opportunityId}/details/${id}/tasks`,
      label: t('lead.tasks')
    },
    {
      key: `/opportunities/${opportunityId}/details/${id}/documents`,
      label: t('lead.documents')
    },
    {
      key: `/opportunities/${opportunityId}/details/${id}/contacts`,
      label: t('lead.contacts')
    }
  ]

  const onChangeTab = (activeKey: string) => navigate(activeKey)

  return (
    <Card variant="borderless">
      <Tabs
        destroyOnHidden
        activeKey={pathname || items[0]?.key}
        onChange={onChangeTab}
        items={items}
      />

      <Outlet />
    </Card>
  )
}
